import { render } from "./PostPicker.html?vue&type=template&id=dd0095ec&scoped=true&ts=true"
import script from "./PostPicker.ts?vue&type=script&lang=ts"
export * from "./PostPicker.ts?vue&type=script&lang=ts"

import "./PostPicker.scss?vue&type=style&index=0&id=dd0095ec&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0095ec"]])

export default __exports__